import React from "react";
import { CollapsePanel } from "./CollapsePanel";
import { DetailGrid, DetailGridItem } from "./DetailGrid";

export const PriorAuthorizationDetails = ({ priorAuthorizationDetails }) => {
  return (
    <CollapsePanel labelText="Prior Authorization Details">
      <DetailGrid className="detail-grid-large">
        <DetailGridItem title="Phone Number" value={priorAuthorizationDetails?.phoneNumber} />
        <DetailGridItem title="Fax Number" value={priorAuthorizationDetails?.faxNumber} />
        <DetailGridItem title="Portal 1" value={priorAuthorizationDetails?.portal1} />
        <DetailGridItem title="Portal 2" value={priorAuthorizationDetails?.portal2} />
        <DetailGridItem title="Portal 3" value={priorAuthorizationDetails?.portal3} />
      </DetailGrid>
    </CollapsePanel>
  );
};
